import * as React from 'react'

function SvgIconFunctionalDiversity(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="functional-diversity"
        aria-labelledby="t-functional-diversity d-functional-diversity"
      >
        <title id="t-functional-diversity">{'Functional diversity'}</title>
        <desc id="d-functional-diversity">
          {'Person on a wheelchair on the move'}
        </desc>
        <path d="M13.226 28.527a6.258 6.258 0 01-6.251-6.25c0-1.299.398-2.508 1.08-3.508l-2.483-2.483a9.676 9.676 0 00-2.068 5.991c0 5.369 4.353 9.723 9.723 9.723 2.26 0 4.339-.773 5.991-2.066l-2.483-2.479a6.266 6.266 0 01-3.509 1.072zM27.958 14.509a1.904 1.904 0 00-1.467-.572l-6.63.369 3.646-4.155a2.233 2.233 0 00.47-2.085 1.872 1.872 0 00-.851-1.204l-8.72-5.067a1.9 1.9 0 00-2.22.225l-4.25 3.794a1.902 1.902 0 102.532 2.838l3.224-2.876 2.666 1.548-4.705 5.358a9.695 9.695 0 00-5.086 2.513l2.457 2.458a6.225 6.225 0 014.201-1.625 6.258 6.258 0 016.251 6.25 6.202 6.202 0 01-1.627 4.201l2.457 2.457a9.686 9.686 0 002.641-6.658 9.695 9.695 0 00-.989-4.271l2.565-.146-.623 7.65a1.899 1.899 0 001.886 2.058c.979 0 1.812-.754 1.896-1.748L28.488 16a1.893 1.893 0 00-.53-1.491zM24.438 6.365a3.187 3.187 0 003.188-3.182A3.194 3.194 0 0024.438 0a3.184 3.184 0 100 6.365z" />
      </g>
    </svg>
  )
}

export default SvgIconFunctionalDiversity
